var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        "hide-footer": !!_setup.selectedEffect,
        value: _setup.isOpen,
        title: "Image Effects",
        size: "xl",
      },
      on: { closed: _setup.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.handleClose },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_setup.selectedEffect
        ? _c(_setup.ImageEffectsPropertiesModalsAddHeader)
        : _vm._e(),
      _vm._v(" "),
      !_setup.selectedEffect
        ? _c(_setup.ImageEffectsPropertiesModalsAddBody)
        : _vm._e(),
      _vm._v(" "),
      _setup.selectedEffect
        ? _c(_setup.ImageEffectSelectedBody, {
            attrs: { effect: _setup.selectedEffect },
            on: { update: _setup.handleUpdate },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }